export const FIELDS = [
  {
    key: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Ex: John ..",
  },
  {
    key: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Ex: Doe ..",
  },
  {
    key: "mobile",
    label: "Mobile Number",
    type: "text",
    min: "8",
    max: "20",
    placeholder: "Ex: +123456789 ..",
  },
  {
    key: "street",
    label: "Street Adderss",
    type: "text",
    placeholder: "Ex: Adderss 1 ..",
  },
  {
    key: "city",
    label: "City",
    type: "text",
    placeholder: "Ex: City name ..",
  },
  {
    key: "zip_code",
    label: "Zip Code",
    type: "text",
    max: "10",
    placeholder: "Ex: 1234 ..",
  },
  {
    key: "invitation_code",
    label: "Invitation Code",
    type: "text",
    placeholder: "Ex: 1s2h34 ..",
  },
  {
    key: "country",
    label: "Country",
    type: "text",
  },
  {
    key: "email",
    label: "Email",
    type: "email",
    placeholder: "Ex: bullit@bullit.app ..",
  },
  {
    key: "password",
    label: "Password",
    type: "password",
    min: "8",
  },
  {
    key: "password_confirmation",
    label: "Confirm Password",
    type: "password",
  },
];
